import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import APIS from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  Button,
  CardTitle,
  Form,
  Label, ModalHeader
} from "reactstrap"
import { withRouter } from "react-router"
//i18n
import { withTranslation } from "react-i18next"
import Select from "react-select"
import API from "../../api"
import { Slide, toast, ToastContainer } from "react-toastify"
import FileDownload from "js-file-download"

const DataTableOrientation = props => {
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const lng = localStorage.getItem("I18N_LANGUAGE")
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [add, setAdd] = useState(0)
  const [excel, setExcel] = useState(0);
  const [delet, setDelet] = useState(0);
  const [id, setId] = useState("")
  const [modal, setModal] = useState(false)
  const [cloture, setCloture] = useState(0);
  const { SearchBar } = Search

  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Liste d'orientation")
    );
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    setDelet(typeArticleSubMenu.sous_menu[0].delete)
    setExcel(typeArticleSubMenu.sous_menu[0].exel)
    const resDep = await APIS.get("parametrage/getdepartement").then(resDep => {
      setDepartement(resDep.data.departement)
    })
    setOrders([])
    setLoading(true)
  }, [])
  const getSpec = async event => {
    setSelectDepartement(event)
    setSelectSpecialite("")
    const resSpec = await APIS.post("geo/listform", {
      departement_id: event.value,
    }).then(resAng => {
      setSpecialite(resAng.data.geo)
    })
    setOrders([])
    const res = await APIS.post("parametrage/list_all", {
      annee_id,
    }).then(res => {
      switch (event.value) {
        case 164:
          setOrders(res.data.data.geos)
          break
        case 165:
          setOrders(res.data.data.histoires)
          break
        case 162:
          setOrders(res.data.data.anglais)
          break
        case 166:
          setOrders(res.data.data.sociologies)
          break
      }
    })
  }
  const getEtd = async event => {
    setSelectSpecialite(event)
    setOrders([])
    const res = await APIS.post("parametrage/getlistbyspacialite", {
      specialite_id:event.value,
      annee_id,
    }).then(res => {
      switch (selectDepartement.value) {
        case 164:
          setOrders(res.data.data.geos)
          break
        case 165:
          setOrders(res.data.data.histoires)
          break
        case 162:
          setOrders(res.data.data.anglais)
          break
        case 166:
          setOrders(res.data.data.sociologies)
          break
      }
    })
  }
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: props.t("Suivant"),
    prePageText: props.t("Précedent"),
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>Aucun information à afficher</h6>
  )
  const Columns = () => {
    if (!selectDepartement || !selectDepartement.value) {
      return []
    }
    const baseColumns = []
    switch (selectDepartement.value) {
      case 164:
        baseColumns.push(
          {
            dataField: "etudiant_nom_complet",
            text: props.t("اسم الطالب و لقبه"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "cin",
            text: props.t("رقم بطاقة تعريف الوطنية"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "session_name_ar",
            text: props.t("الدورة"),
            sort: true,
            style: {textAlign: "center"},
            headerStyle: () => ({textAlign: "center"})
          },
          {
            dataField: "moyenne_premiere_annee",
            text: props.t("معدل النجاح بالسنة الأولى"),
            sort: true,
            style: {textAlign: "center"},
            headerStyle: () => ({textAlign: "center"})
          },
          {
            dataField: "specialite_name_fr",
            text: props.t("المسالك"),
            sort: true,
            style: {
              textAlign: "center",
            },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_mp",
            text: props.t("معدل وحدة الخرائطية بالسنة الأولى"),
            sort: true,
            style: {
              textAlign: "center",
            },
            headerStyle: () => ({ textAlign: "center" }),
          }
        )

        break
      case 165:
        baseColumns.push(
          {
            dataField: "etudiant_nom_complet",
            text: props.t("اسم الطالب و لقبه"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "cin",
            text: props.t("رقم بطاقة تعريف الوطنية"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "specialite_name_fr",
            text: props.t("المسالك"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_premiere_annee",
            text: props.t("معدل النجاح بالسنة الأولى "),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "session_name_ar",
            text: props.t("الدورة "),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_mp1",
            text: props.t("معدل التاريخ القديم "),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_mp2",
            text: props.t("معدل التاريخ الوسيط "),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_mp3",
            text: props.t("معدل التاريخ الحديث "),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_mp4",
            text: props.t("معدل التاريخ المعاصر"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          }
        )
        break
      case 162:
        baseColumns.push(
          {
            dataField: "etudiant_nom_complet",
            text: props.t("Nom et prénom"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "cin",
            text: props.t("CIN"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "choi1_name_fr",
            text: props.t("1er Choix de Spécialité"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "choi2_name_fr",
            text: props.t("2ème Choix de Spécialité"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "session_name_fr",
            text: props.t("Admis Session"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_premiere_annee",
            text: props.t("Moyenne Annuelle en 1ère Année"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          }
        )
        break
      case 166:
        baseColumns.push(
          {
            dataField: "etudiant_nom_complet",
            text: props.t("اسم الطالب و لقبه"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "cin",
            text: props.t("رقم بطاقة تعريف الوطنية"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          }
          ,{
            dataField: "session_name_ar",
            text: props.t("الدورة"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "choi1_name_fr",
            text: props.t("الإختيار الأول  لأحد المسالك"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "choi2_name_fr",
            text: props.t("الإختيار الثاني  لأحد المسالك"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          },
          {
            dataField: "moyenne_premiere_annee",
            text: props.t("معدل النجاح بالسنة الأولى"),
            sort: true,
            style: { textAlign: "center" },
            headerStyle: () => ({ textAlign: "center" }),
          }
        )
        break
      default:
        return []
    }
    baseColumns.push(
      {
        dataField: "Suppression",
        text: "Suppression",
        sort: true,
        style: { textAlign: "center" },
        headerStyle: (colum, colIndex) => {
          return { textAlign: "center" }
        },
        // eslint-disable-next-line react/display-name
        formatter: (cellContent, row) =>
          delet === 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#ED6464", cursor: "pointer" }}
                onClick={() => toggle(row.id)}
                className="fas fa-trash-alt"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-trash-alt"
              ></i>
            </div>
          ),
        center: true,
        reorder: true,
      },
    )
    return baseColumns
  }
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const toggleExcelDepartement = async () => {
    if(selectDepartement !==""){
      await API.post(
        'excel/list_demande_bydepartement',
        {
          departement_id: selectDepartement.value,
          annee_id,
        },
        { responseType: "blob" }
      )
        .then(async (response) => {
          try {
            const text = await response.data.text();
            const jsonResponse = JSON.parse(text);

            if (jsonResponse.errNum === 301 || jsonResponse.errNum === "301") {
              toast.error("⛔ " + jsonResponse.msg, {
                containerId: "A",
              });
            } else {
              toast.error("Erreur inconnue !");
            }
          } catch (error) {
            FileDownload(response.data, `Liste orientation par département ${selectDepartement.label}.xlsx`);
          }
        })
        .catch((error) => {
          console.error("Erreur lors de l'appel API :", error);
          toast.error("Une erreur est survenue lors de la récupération des données.");
        });
    }else{
      toast.error("Voulez-vous choisir un département !", {
        containerId: "A",
      })
    }

  };
  const toggleExcelSpecialite = async () => {
    if(selectSpecialite !== ""){
      await API.post(
        'excel/list_demande_byspacialite',
        {
          specialite_id: selectSpecialite.value,
          annee_id,
        },
        { responseType: "blob" }
      )
        .then(async (response) => {
          try {
            const text = await response.data.text();
            const jsonResponse = JSON.parse(text);

            if (jsonResponse.errNum === 301 || jsonResponse.errNum === "301") {
              toast.error("⛔ " + jsonResponse.msg, {
                containerId: "A",
              });
            } else {
              toast.error("Erreur inconnue !");
            }
          } catch (error) {
            FileDownload(response.data, `Liste orientation pour la spécialité ${selectSpecialite.label}.xlsx`);
          }
        })
        .catch((error) => {
          console.error("Erreur lors de l'appel API :", error);
          toast.error("Une erreur est survenue lors de la récupération des données.");
        });
    }else{
      toast.error("Voulez-vous choisir une spécialité !", {
        containerId: "A",
      })
    }

  };
  const toggleDelete = async () => {
    const res = await API.post("parametrage/deleteInscription", {
      id: id,
      annee_id,
      user_id,
      departement_id:selectDepartement.value
    }).then(resA => {
      setModal(false)
      const resSpec =  APIS.post("geo/listform", {
        departement_id: selectDepartement.value,
      }).then(resAng => {
        setSpecialite(resAng.data.geo)
      })
      setOrders([])
      const res =  APIS.post("parametrage/list_all", {
        annee_id,
      }).then(res => {
        switch (selectDepartement.value) {
          case 164:
            setOrders(res.data.data.geos)
            break
          case 165:
            setOrders(res.data.data.histoires)
            break
          case 162:
            setOrders(res.data.data.anglais)
            break
          case 166:
            setOrders(res.data.data.sociologies)
            break
        }
      })
    })
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <CardTitle style={{ color: "#556ee6" }} className="h4">
              Critéres de Recherches
            </CardTitle>
            <Form className="mt-4">
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Département :</Label>
                    <Select
                      options={departement}
                      isSearchable={true}
                      onChange={e => getSpec(e)}
                      value={selectDepartement}
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Spécialité :</Label>
                    <Select
                      options={specialite}
                      isSearchable={true}
                      value={selectSpecialite}
                      onChange={e => getEtd(e)}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
            <div style={{ display: "flex", justifyContent: "center" }}>

              <Col lg="12">
                <div className="text-center mt-4">
                  {excel === 1 ? (
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#999f15",
                          borderColor: "#999f15",
                        }}
                        className="btn btn-success mb-2 me-2"
                        onClick={toggleExcelDepartement}>
                        {"Exportation la liste des étudiants par département"}
                      </button>
                    ) : null}
                  {excel === 1 ? (
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#03667a",
                          borderColor: "#03667a",
                        }}
                        className="btn btn-success mb-2 me-2"
                        onClick={toggleExcelSpecialite}>
                        {"Exportation la liste des étudiants par spécialité"}
                      </button>
                    ) : null}
                    </div>
              </Col>

            </div>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    {Columns().length > 0 && (
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        noDataIndication={() => <NoDataIndication />}
                        striped={false}
                        bordered={false}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"table-light"}
                        hover
                        pagination={paginationFactory(pageOptions)}
                        {...toolkitProps.baseProps}
                      />
                    )}
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {" Suppression orientation étudiant"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cet orientation étudiant ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableOrientation))
DataTableOrientation.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
